import React from 'react';
import './PrivateCloudSolutionsOffer.css';
import a from './img1.png';
import b from './img2.png';
import c from './img3.png';

const fitItems = [
    'עסקים שצריכים סביבת ענן ייעודית ומבודדת.',
    'חברות עם מערכות קריטיות שדורשות יציבות גבוהה.',
    'ארגונים שרוצים יותר שליטה על תשתית, הרשאות וביצועים.',
    'עסקים עם דרישות אבטחה או תאימות גבוהות יותר.',
    'חברות שרוצות לעבור מסביבה קיימת לפתרון מנוהל ומסודר יותר.',
    'ארגונים שצריכים זמינות גבוהה והתאוששות עסקית טובה יותר.'
];

const problemItems = [
    'סביבת האירוח הנוכחית כבר לא מספיקה לצרכים העסקיים.',
    'אין מספיק שליטה על התשתית.',
    'יש מגבלות בביצועים, בגמישות או בסקלביליות.',
    'קשה להבטיח יציבות עקבית למערכות קריטיות.',
    'יש חששות סביב אבטחה, בידוד או רגולציה.',
    'עלויות גדלות בלי מבנה נכון או בקרה מספקת.',
    'התשתית מפוזרת מדי בין כמה פתרונות.',
    'חסר גורם מקצועי שמנהל את הסביבה באופן פרואקטיבי.'
];

const audienceSignals = [
    'אם אתם צריכים סביבת ענן שמותאמת באמת לדרישות שלכם.',
    'אם מערכות קריטיות אצלכם כבר לא יכולות להסתמך על תשתית כללית מדי.',
    'אם אתם מחפשים יותר שליטה, בידוד ואמינות תפעולית.',
    'אם אתם רוצים לשפר זמינות, גיבוי והתאוששות בלי להעמיס על הצוות.',
    'אם אתם שוקלים מעבר לענן פרטי או שיפור של סביבת תשתית קיימת.'
];

const processSteps = [
    {
        number: '01',
        title: 'שיחת היכרות והבנת הצרכים',
        text: 'ממפים את המערכות, הדרישות, האילוצים והיעדים העסקיים.'
    },
    {
        number: '02',
        title: 'ניתוח מצב קיים',
        text: 'בודקים תשתית קיימת, פערי שליטה, ביצועים, אבטחה ודרישות שרידות.'
    },
    {
        number: '03',
        title: 'בניית כיוון ברור',
        text: 'מגדירים ארכיטקטורה, מעבר או שיפור סביבה בהתאם לצרכים בפועל.'
    },
    {
        number: '04',
        title: 'ליווי בהקמה ובהמשך',
        text: 'ממשיכים בניהול, תמיכה ואופטימיזציה כדי לשמור על יציבות לאורך זמן.'
    }
];

const trustPoints = [
    'ניסיון בתשתיות, ענן, ניהול מערכות וזמינות גבוהה.',
    'גישה פרקטית שמחברת בין צורך עסקי, ארכיטקטורה ותפעול.',
    'ניהול אקטיבי ולא רק הקמה חד-פעמית.',
    'התאמה לעסקים שצריכים תשתית רצינית בלי לבנות הכול לבד.'
];

const bookingUrl = 'https://meetings.hubspot.com/viacheslav-seifer';

const PrivateCloudSolutionsOffer = () => {
    const scrollToForm = () => {
        const formElement = document.getElementById('epic-private-cloud-form');
        if (formElement) {
            formElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

    return (
        <section className="private-cloud-solutions-offer">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-9 text-center">
                        <h2 className="offer-title">ענן פרטי לעסקים שצריכים יותר שליטה, יציבות ואבטחה</h2>
                        <p className="lead offer-description">
                            אנחנו בונים ומנהלים סביבות Private Cloud ייעודיות שמותאמות
                            לצרכים העסקיים שלכם, עם דגש על בידוד, זמינות גבוהה, גמישות תפעולית
                            וניהול אקטיבי לאורך זמן.
                        </p>
                        <div className="private-cloud-cta-row">
                            <button
                                type="button"
                                className="btn btn-primary btn-lg cta-btn"
                                onClick={scrollToForm}
                            >
                                השאירו פרטים
                            </button>
                            <a
                                href={bookingUrl}
                                target="_blank"
                                rel="noreferrer"
                                className="btn btn-outline-primary btn-lg cta-btn"
                            >
                                קבעו שיחת ייעוץ
                            </a>
                        </div>
                    </div>
                </div>

                <div className="row info-block">
                    <div className="col-lg-10 mx-auto">
                        <div className="section-card">
                            <h3 className="section-title">למי זה מתאים</h3>
                            <div className="bullet-grid">
                                {fitItems.map((item) => (
                                    <div key={item} className="bullet-card">
                                        <span className="bullet-icon">•</span>
                                        <p>{item}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row info-block">
                    <div className="col-lg-10 mx-auto">
                        <div className="section-card">
                            <h3 className="section-title">האם זה נשמע מוכר?</h3>
                            <div className="bullet-grid">
                                {problemItems.map((item) => (
                                    <div key={item} className="bullet-card">
                                        <span className="bullet-icon">•</span>
                                        <p>{item}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row align-items-center private-cloud-main-section">
                    <div className="col-md-6">
                        <h3>ענן פרטי הוא לא רק עוד פתרון אירוח</h3>
                        <p>
                            כשמערכות עסקיות הופכות קריטיות, תשתית גנרית כבר לא תמיד מספיקה.
                            עסקים רבים גדלו מעבר לסביבה הנוכחית שלהם ועכשיו צריכים בסיס תשתיתי
                            מסודר, נשלט ואמין יותר.
                        </p>
                        <p>
                            המטרה היא לא רק להעביר מערכות לענן, אלא לבנות סביבת עבודה מבודדת,
                            יציבה ומנוהלת נכון, שמתאימה לדרישות התפעוליות והעסקיות בפועל.
                        </p>
                        <div className="signal-list">
                            {audienceSignals.map((item) => (
                                <div key={item} className="signal-item">{item}</div>
                            ))}
                        </div>
                    </div>
                    <div className="col-md-6">
                        <img src={a} alt="ענן פרטי מותאם וגמישות תפעולית" className="img-fluid" />
                    </div>
                </div>

                <div className="row align-items-center private-cloud-secondary-section">
                    <div className="col-md-6">
                        <img src={b} alt="בידוד, אבטחה ובקרות בענן פרטי" className="img-fluid" />
                    </div>
                    <div className="col-md-6">
                        <h3>איך אנחנו עוזרים</h3>
                        <p>
                            אנחנו מספקים פתרונות Private Cloud מותאמים, סביבה ייעודית ומבודדת,
                            גמישות בהקצאת משאבים, זמינות גבוהה, גיבוי, שחזור ותמיכה בהמשכיות
                            עסקית.
                        </p>
                        <p>
                            העבודה שלנו כוללת גם ליווי בתהליך Migration לענן פרטי, גם שיפור של
                            סביבת ענן קיימת, וגם ניהול אקטיבי שוטף שמוריד עומס מהצוות הפנימי.
                        </p>
                        <div className="signal-list">
                            <div className="signal-item">פתרונות Private Cloud מותאמים</div>
                            <div className="signal-item">סביבה ייעודית ומבודדת</div>
                            <div className="signal-item">אבטחה ובקרות מחמירות יותר</div>
                            <div className="signal-item">זמינות גבוהה וארכיטקטורת שרידות</div>
                            <div className="signal-item">ליווי במעבר לענן פרטי או בשיפור סביבה קיימת</div>
                        </div>
                    </div>
                </div>

                <div className="row align-items-center private-cloud-support-section">
                    <div className="col-md-6">
                        <h3>מה יוצא לכם מזה</h3>
                        <p>
                            יותר שליטה על הסביבה, תשתית יציבה ואמינה יותר, בידוד ואבטחה ברמה
                            גבוהה יותר ובסיס נכון לצמיחה.
                        </p>
                        <p>
                            התוצאה היא זמינות טובה יותר, התאוששות טובה יותר מאירועי כשל, פחות
                            עומס על הצוות הפנימי ויותר ביטחון בהמשכיות ובתפעול.
                        </p>
                        <div className="signal-list">
                            <div className="signal-item">יותר שליטה על הסביבה</div>
                            <div className="signal-item">תשתית יציבה ואמינה יותר</div>
                            <div className="signal-item">זמינות גבוהה יותר והתאוששות טובה יותר</div>
                            <div className="signal-item">פחות עומס על הצוות הפנימי</div>
                            <div className="signal-item">סביבת ענן שאפשר לסמוך עליה לאורך זמן</div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <img src={c} alt="ניהול אקטיבי ותמיכה שוטפת בענן פרטי" className="img-fluid" />
                    </div>
                </div>

                <div className="row info-block">
                    <div className="col-lg-10 mx-auto">
                        <div className="section-card">
                            <h3 className="section-title">איך זה עובד</h3>
                            <div className="process-grid">
                                {processSteps.map((step) => (
                                    <div key={step.number} className="process-card">
                                        <span className="process-number">{step.number}</span>
                                        <h4>{step.title}</h4>
                                        <p>{step.text}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row info-block">
                    <div className="col-lg-10 mx-auto">
                        <div className="section-card">
                            <h3 className="section-title">למה לעבוד איתנו</h3>
                            <div className="trust-grid">
                                {trustPoints.map((item) => (
                                    <div key={item} className="trust-item">{item}</div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row justify-content-center">
                    <div className="col-lg-8 text-center">
                        <div className="final-cta-card">
                            <h3>אם התשתית הנוכחית כבר לא נותנת לכם מספיק שליטה וביטחון, זה הזמן לעשות סדר</h3>
                            <p className="lead">
                                בואו נבין מה צריך לייצב, לבודד או לשפר כדי לבנות סביבת ענן פרטית נכונה יותר.
                            </p>
                            <div className="private-cloud-cta-row">
                                <button
                                    type="button"
                                    className="btn btn-light btn-lg cta-btn"
                                    onClick={scrollToForm}
                                >
                                    השאירו פרטים
                                </button>
                                <a
                                    href={bookingUrl}
                                    target="_blank"
                                    rel="noreferrer"
                                    className="btn btn-outline-light btn-lg cta-btn"
                                >
                                    קבעו שיחת ייעוץ
                                </a>
                            </div>
                            <p className="cta-note">שיחה ראשונית ללא התחייבות. חזרה תוך 24 שעות.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default PrivateCloudSolutionsOffer;
